import { render } from "./AvrModal.vue?vue&type=template&id=1c4af97d"
import script from "./AvrModal.vue?vue&type=script&lang=js"
export * from "./AvrModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__